import React, { useState } from 'react';
import Popover from "@mui/material/Popover";
import './ProfileButton.scss';

interface ProfileButtonProps {
    style?: React.CSSProperties;
    commonProps?: any;
    profileThumbnailStyle: React.CSSProperties;
    popoverStyle: any;
    profileImageStyle: React.CSSProperties;
    profileNameStyle: React.CSSProperties;
    profileEmailStyle: React.CSSProperties;
    authButtonStyle: React.CSSProperties;
    displayMode?: 'popover' | 'expanded'; // Nueva prop para controlar el modo de visualización
}

const ProfileButton: React.FC<ProfileButtonProps> = ({
    style,
    commonProps,
    profileThumbnailStyle,
    popoverStyle,
    profileImageStyle,
    profileNameStyle,
    profileEmailStyle,
    authButtonStyle,
    displayMode = 'popover', // Valor predeterminado
}) => {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const handlePresentPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    const handleClosePopover = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    return (
        <div style={{
            width: '100%'
        }} className='profile-button-container'>
            {displayMode === 'popover' ? (
                <>
                    <button
                        style={{
                            ...style,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                        onClick={handlePresentPopover}>
                        <img style={profileThumbnailStyle} src={"assets/profile-image.svg"} alt="" />
                    </button>
                    <Popover
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClosePopover}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        className="profile-button-popover"
                        PaperProps={{
                            sx: popoverStyle,
                        }}
                    >
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: 5
                        }}>
                            <img style={profileImageStyle} src={"assets/profile-image.svg"} alt="" />
                        </div>

                        <div style={profileNameStyle}>
                            Mi usuario
                        </div>
                        <div style={profileEmailStyle}>
                            mi@email.com
                        </div>
                    </Popover>
                </>
            ) : (
                <div className='expanded-profile'>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 5
                    }}>
                        <img style={profileImageStyle} src={"assets/profile-image.svg"} alt="" />
                    </div>
                    <div style={profileNameStyle}>
                        Mi usuario
                    </div>
                    <div style={profileEmailStyle}>
                        mi@email.com
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfileButton;